<template>
    <v-container fluid grid-list-sm>
        <v-row>
            <v-col cols="12" sm="9">
                <h3 class="display-1 primary--text">Customers</h3>
            </v-col>
            <v-col cols="12" sm="3">
                <v-btn @click="createCustomer" x-large class="float-right" color="primary" fab icon><v-icon>mdi-pencil</v-icon></v-btn>
            </v-col>
            <v-col cols="12" sm="3">
                <v-text-field v-on:click:clear="clearSearch" :loading="isLoading" v-debounce:500ms="searchForCustomer" label="Search for customer" v-model="search" clearable />
            </v-col>
            <v-col cols="12" sm="12">
                <v-data-table :loading="isLoading" :headers="headers" :items="customers" class="elevation-1 mt-5">
                    <template v-slot:item.vrm="{item}">
                        <span v-if="item.vrm" class="vrm"> {{ item.vrm }} </span><span v-else>N/A</span>
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-icon large color="info" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                        <v-icon large color="error" @click="deleteItem(item)">mdi-delete</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Customers",
        computed: {
            customers: {
                get() {
                    return this.$store.state.customers.customers;
                }
            }
        },
        methods: {
            async editItem(item) {
                await this.$store.dispatch('customers/setActiveCustomer', item);
                await this.$store.dispatch('customers/setManageCustomerDialog', true);
            },
            async createCustomer() {
                await this.$store.dispatch('customers/setActiveCustomer', {});
                await this.$store.dispatch('customers/setManageCustomerDialog', true);
            },
            async deleteItem(item) {
                await this.$store.dispatch('customers/setActiveCustomer', item);
                await this.$store.dispatch('customers/setManageDeleteCustomerDialog', true);
            },
            clearSearch() {
                this.$store.dispatch('customers/setCustomers');
            },
            async searchForCustomer() {
                if (this.search.length > 3) {
                    this.isLoading = true;
                    await this.$store.dispatch('customers/searchForCustomers', this.search);
                    this.isLoading = false;
                }
            }
        },
        data() {
            return {
                isLoading: false,
                search: '',
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Email', value: 'email' },
                    { text: 'Phone', value: 'phone' },
                    { text: 'Registration', value: 'vrm' },
                    { text: 'Actions', value: 'actions', sortable: false }
                ]
            }
        }
    }
</script>

<style scoped>

</style>
